import React, { useEffect } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link, useNavigate } from 'react-router-dom';
import { carData } from '../cars/carData';
import { ROUTES } from '../../../config/routingUrl';
import { Button } from 'react-bootstrap';
import { MdArrowRight, MdArrowLeft, MdPerson, MdModelTraining, MdColorize, MdLocationOn } from 'react-icons/md'; // Import both left and right icons
import "./HomeEcommerce.css"
import { useDispatch, useSelector } from 'react-redux';
import { fetchVehiclesAll, fetchVehiclesAllFilter, fetchVehiclesAllResearch, fetchVehiclesAllResearchAvailable } from '../../../actions/request/VehicleRequest';
import { fetchPropertysAll, fetchPropertysAllResearch, fetchPropertysAllResearchAvailable } from '../../../actions/request/PropertyRequest';
import { FETCH_PROPERTY_SUCCESS, FETCH_RESERVATION_SUCCESS, FETCH_VEHICLE_SUCCESS } from '../../../app/actions/actions';
import { currentDate, emptyImage } from '../../../utils/dataApi/dataFormApi';
import { LuPhone } from 'react-icons/lu';
import { useState } from 'react';



const HomeEcommerce = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const vehicles = useSelector((state) => state.vehicles.vehiclesAvailable);
    const propertys = useSelector((state) => state.propertys.propertysAvailable);

    useEffect(() => {
        dispatch(fetchVehiclesAllResearchAvailable(currentDate, currentDate))
        dispatch(fetchPropertysAllResearchAvailable(currentDate, currentDate))
    }, [])

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1200 },
            items: 4,
        },
        desktop: {
            breakpoint: { max: 1200, min: 992 },
            items: 4,
        },
        tablet: {
            breakpoint: { max: 992, min: 768 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1,
        },
    };


    // État pour gérer le survol de chaque élément
    const [hoverStates, setHoverStates] = useState({});

    // Fonction pour mettre à jour l'état de survol d'un élément spécifique
    const handleMouseEnter = (id) => {
        setHoverStates((prevState) => ({
            ...prevState,
            [id]: true,
        }));
    };

    const handleMouseLeave = (id) => {
        setHoverStates((prevState) => ({
            ...prevState,
            [id]: false,
        }));
    };



    return (
        <>
            {/*vehicles */}
            <div className="container-fluid" style={{ padding: "100px 0px 100px 0px" }}>
                <div className="container-fluid" style={{ display: "flex", flexDirection: "column", justifyContent: "center", }}>
                    <div><h5 style={{ color: "#43B613", textAlign: "center" }}>VOITURES RÉCEMMENT AJOUTÉES</h5></div>
                    <div><h2 style={{ color: "#737373", textAlign: "center" }}>Nos nouvelles options de location sont là ! </h2></div>
                    <div><p style={{ color: "#A6A6A6", textAlign: "center" }}>
                        Jetez un œil aux véhicules tout juste intégrés à notre catalogue, prêts à vous accompagner partout.
                    </p></div>
                </div>

                {/*listes de vehoicule */}
                {vehicles && vehicles.length > 0 && vehicles.filter((item) => item.isVisible == true).length > 0 && (
                    <div className="container-fluid" style={{ padding: "50px 10px 50px 10px" }}>

                        <Carousel responsive={responsive} autoPlay={true} infinite={true} transitionDuration={8} >

                            {vehicles && vehicles.length > 0 &&
                                vehicles.filter((item) => item.isVisible == true).map((item) => {
                                    const isHovered = hoverStates[item._id]; // Vérifie si l'élément actuel est survolé
                                    return (
                                        <div className="shadow-sm rounded-lg" style={{ margin: "10px", overflow: "hidden", }}
                                            onMouseEnter={() => handleMouseEnter(item._id)} // Déclenche lorsqu'on survole
                                            onMouseLeave={() => handleMouseLeave(item._id)} // Déclenche lorsque la souris quitte
                                        >
                                            <div style={{ background: "#F2F2F2" }}>
                                                <img src={item?.images && item?.images.length > 0 ? item?.images[0] : emptyImage} style={{
                                                    height: "200px", width: "100%",
                                                    transition: "transform 0.3s ease-in-out",
                                                    transform: isHovered ? "scale(1.1)" : "scale(1)", // Zoom léger sur l'image
                                                }} />
                                            </div>
                                            <div style={{ background: "white", padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                                                <div><h6 style={{ color: "#737373" }}>{item.brand||""}</h6></div>
                                                <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                                                    <div>
                                                        <span style={{ fontWeight: "bold", fontSize: "25px" }} className="font-bold"> {item.basePricePerDay || 0} </span>
                                                        <span style={{ fontWeight: "bold", fontSize: "12px" }}>DZD</span>
                                                        <span style={{ color: "#A6A6A6", fontSize: "12px" }}>/Jour</span>
                                                    </div>
                                                    <div>
                                                        {
                                                            /*
                                                            <span style={{ color: "#A6A6A6", fontSize: "12px" }}> <MdLocationOn /> Algerie</span>
                                                             */
                                                        }
                                                    </div>
                                                </div>
                                                <div>
                                                    <Button type="button"
                                                        onClick={() => {

                                                            dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: item });
                                                            dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} });
                                                            navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.brand}/description/${item.brand}`);
                                                        }}
                                                        style={{
                                                            padding: "10px 5px",
                                                            color: isHovered ? "white" : "#000", // Change la couleur du texte
                                                            borderRadius: "30px",
                                                            textAlign: "center",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            transition: "all 0.3s ease-in-out", // Animation fluide
                                                        }}
                                                        variant={isHovered ? "primary" : "outline-dark"} // Change le variant du bouton
                                                        className={`w-100 ${isHovered ? "text-white" : ""}`}
                                                    >
                                                        <div style={{ display: "flex", justifyContent: "space-between", alignContent: "center" }}>
                                                            <div className="p-1"><LuPhone /> </div> <div className="p-1"><span className="text-center"> Réserver maintenant </span> </div>
                                                        </div>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </Carousel>
                    </div>
                )}

                <div style={{ display: "flex", justifyContent: "center", margin: "30px 0px 0px 0px" }}>
                    <Button type="button" onClick={() => { navigate(`/${ROUTES.CAR_LIST_WEB}`) }} style={{ padding: "10px 10px 10px 10px", color: "white", borderRadius: "30px", textAlign: "center", display: "flex", justifyContent: "center" }} variant="dark" className="">
                        <div style={{ display: "flex", justifyContent: "space-between", alignContent: "center" }}>
                            <div className="p-1"><span className="text-center"> Voir plus </span> </div>
                        </div>
                    </Button>
                </div>
            </div>

            {/*porperty */}
            <div className="container-fluid" style={{ padding: "100px 0px 100px 0px" }}>
                <div className="container-fluid" style={{ display: "flex", flexDirection: "column", justifyContent: "center", }}>
                    <div><h5 style={{ color: "#43B613", textAlign: "center" }}>NOUVELLES PROPRIÉTÉS DISPONIBLES </h5></div>
                    <div><h2 style={{ color: "#737373", textAlign: "center" }}>Des opportunités fraîchement ajoutées </h2></div>
                    <div>
                        <p style={{ color: "#A6A6A6", textAlign: "center" }}>
                            Explorez les dernières propriétés mises en ligne et réservez en toute simplicité avec Mareza.
                        </p>
                    </div>
                </div>

                {/*listes de vehoicule */}
                <div className="container-fluid" style={{ padding: "50px 10px 50px 10px" }}>

                    <Carousel responsive={responsive} autoPlay={true} infinite={true} transitionDuration={8}  >

                        {
                            propertys && propertys.length > 0 &&
                            propertys.filter((item) => item.isVisible == true).length > 0 &&
                            propertys.filter((item) => item.isVisible == true).map((item) => {
                                // État unique pour chaque élément
                                const isHovered = hoverStates[item._id]; // Vérifie si l'élément actuel est survolé
                                return (
                                    <div className="shadow-sm rounded-lg" style={{ margin: "10px", overflow: "hidden", }}
                                        onMouseEnter={() => handleMouseEnter(item._id)} // Déclenche lorsqu'on survole
                                        onMouseLeave={() => handleMouseLeave(item._id)} // Déclenche lorsque la souris quitte
                                    >
                                        <div style={{ background: "#F2F2F2" }}>
                                            <img src={item?.images && item?.images.length > 0 ? item?.images[0] : emptyImage} style={{
                                                height: "200px", width: "100%",
                                                transition: "transform 0.3s ease-in-out",
                                                transform: isHovered ? "scale(1.1)" : "scale(1)", // Zoom léger sur l'image
                                            }} />
                                        </div>
                                        <div style={{ background: "white", padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                                            <div><h6 style={{ color: "#737373" }}>{item.name||""}</h6></div>
                                            <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                                                <div>
                                                    <span style={{ fontWeight: "bold", fontSize: "25px" }} className="font-bold"> {item.basePricePerDay || 0}</span>
                                                    <span style={{ fontWeight: "bold", fontSize: "14px" }}>DZD</span>
                                                    <span style={{ color: "#A6A6A6", fontSize: "14px" }}>/Jour</span>
                                                </div>
                                                <div style={{ alignContent: "center" }}>
                                                    <span
                                                        style={{ color: "#A6A6A6", fontSize: "14px" }}
                                                        className="text-truncate"
                                                    >
                                                        <MdLocationOn />{" "}
                                                        {item.address.length > 15 ? `${item.address.slice(0, 15)}...` : item.address}
                                                    </span>
                                                </div>
                                            </div>
                                            <div>
                                                <Button type="button" onClick={() => {

                                                    dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} });
                                                    dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: item });
                                                    navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.name}/description/${item.name}`);
                                                }}
                                                    style={{
                                                        padding: "10px 5px",
                                                        color: isHovered ? "white" : "#000", // Change la couleur du texte
                                                        borderRadius: "30px",
                                                        textAlign: "center",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        transition: "all 0.3s ease-in-out", // Animation fluide
                                                    }}
                                                    variant={isHovered ? "primary" : "outline-dark"} // Change le variant du bouton
                                                    className={`w-100 ${isHovered ? "text-white" : ""}`}
                                                >
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignContent: "center" }}>
                                                        <div className="p-1"><LuPhone /> </div> <div className="p-1"><span className="text-center"> Réserver maintenant </span> </div>
                                                    </div>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Carousel>
                </div>

                <div style={{ display: "flex", justifyContent: "center", margin: "30px 0px 0px 0px" }}>
                    <Button type="button" onClick={() => { navigate(`/${ROUTES.CAR_LIST_WEB}`) }} style={{ padding: "10px 10px 10px 10px", color: "white", borderRadius: "30px", textAlign: "center", display: "flex", justifyContent: "center" }} variant="dark" className="">
                        <div style={{ display: "flex", justifyContent: "space-between", alignContent: "center" }}>
                            <div className="p-1"><span className="text-center"> Voir plus </span> </div>
                        </div>
                    </Button>
                </div>
            </div>
        </>
    );
};

// Custom left arrow button
const CustomLeftArrow = ({ onClick }) => {
    return (
        <Button variant='primary' onClick={onClick}>
            <i className="carousel-arrow"><MdArrowLeft /></i> {/* Left arrow icon */}
        </Button>
    );
};

// Custom right arrow button
const CustomRightArrow = ({ onClick }) => {
    return (
        <Button variant='primary' onClick={onClick}>
            <i className="carousel-arrow"><MdArrowRight /></i> {/* Right arrow icon */}
        </Button>
    );
};

export default HomeEcommerce;
